module.exports = __webpack_public_path__ + "fonts/3954.5c3471e6.eot";